import React, { Component } from 'react';
import OfficebookingLogo from '../../assets/images/officebooking.png'

class Header extends Component {
    render() {
        return (
            <div className="header">
                <div className="header-content d-flex justify-content-center">
                    {/* <img src={OfficebookingLogo} /> */}
                </div>
            </div>
        )
    }
}

export default Header;
